import login from '@tencent/vft-core-login';
export * from '@tencent/vft-core-login';
export default login;